import { cloneDeep, isEmpty } from 'lodash';
import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import * as componentAction from '../store/component.action';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import { poTemplatemodel, imageUrl } from '../../../Components/helper';

export const StateContext = createContext(null);

const orderDetails = {
  type: 'container',
  isStatic: true,
  key: 'order_details',
  id: '14',
  label: 'Order Details',
};

const models = {
  dropzones: [orderDetails],
};

export default function AddPOTemplateProvider({ children }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams();
  const { t } = useTranslation('common');
  const searchParams = new URLSearchParams(location?.search);
  const isDuplicate = searchParams.get('forDuplication');
  const initialState = {
    editPopup: false,
    editpopupData: null,
    editpopupChildData: null,
    editPopupIndex: -1,
    editPopupParentIndex: -1,
    editPopupChildIndex: -1,
    leftColumn: poTemplatemodel,
    poDetails: {
      name: '',
      isActive: false,
      image: null,
      originalImg: null,
      nameErr: false,
    },
    showUpload: false,
    rigthColumn: {
      name: '',
      nameErr: false,
      poOrderNo: null,
      visible: {
        singular: false,
        multiple: false,
        ratio: false,
        multipleTotalPacks: false,
      },
      image: null,
      originalImg: null,
      isActive: false,
      isDeleted: false,
      templateJsonSchema: [...models.dropzones],
    },
  };
  const [poTemplateState, setPOTemplateState] = useState({ ...initialState });
  const reducerState = useSelector((redState) => redState);
  const {
    ComponentOrderReducer: { editData },
    UserDetails: { userInfo },
  } = reducerState;

  useEffect(() => {
    return () => {
      setPOTemplateState(initialState);
      dispatch(componentAction.clearReducer());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      const callFn = async () => {
        await dispatch(componentAction.fetchEditTemplate(id, 'fromPO'));
      };
      callFn();
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (editData && !isEmpty(editData)) {
      let rightPrevObje;
      const existOrderTable = editData?.templateJsonSchema.filter((e) => {
        return e.key === 'order_details';
      });
      const poPrevObj = {
        name: editData?.name,
        image: editData?.image,
        isActive: editData?.isActive,
      };
      delete editData?.name;
      delete editData?.image;
      delete editData?.isActive;
      if (existOrderTable.length === 0) {
        const insertOrderTable = cloneDeep(editData);
        insertOrderTable.templateJsonSchema.unshift(...models.dropzones);
        rightPrevObje = { ...insertOrderTable };
      } else {
        rightPrevObje = { ...editData };
      }
      setPOTemplateState((prevData) => ({
        ...prevData,
        rigthColumn: rightPrevObje,
        poDetails: poPrevObj,
      }));
    }
  }, [editData]);

  const onChangeForData = (e, name) => {
    const data = cloneDeep(poTemplateState.poDetails);
    if (name === 'PO_Template_Button') {
      data.isActive = e;
    } else if (name === 'template_name') {
      data.name = e?.target?.value.trimStart();
    } else {
      setPOTemplateState((previousData) => ({
        ...previousData,
        showUpload: true,
      }));
    }
    setPOTemplateState((previousData) => ({
      ...previousData,
      poDetails: data,
    }));
  };

  const ifNotBase64Image = () => {
    return poTemplateState?.poDetails?.image ? `${imageUrl}/${poTemplateState?.poDetails?.image}` : '';
  };

  const imageSrc = () => {
    return poTemplateState?.poDetails?.image?.includes('base64') ? poTemplateState?.poDetails?.image : ifNotBase64Image();
  };

  let maxId = 5;

  const incrementCounter = () => {
    maxId += 1;
    return Number(maxId) + 1;
  };

  const toggleEditPopup = () => {
    setPOTemplateState((otherStates) => ({
      ...otherStates,
      editPopup: false,
      editpopupData: null,
      editpopupChildData: null,
      editPopupIndex: -1,
      editPopupParentIndex: -1,
      editPopupChildIndex: -1,
    }));
  };

  const dropLocation = (index, item) => {
    const updatedLeft = cloneDeep(poTemplateState?.leftColumn);
    const newObject = poTemplateState?.rigthColumn;
    const rightSideKeys = newObject?.templateJsonSchema.map((ele) => ele?.key);
    const arrayToCheck = rightSideKeys.filter((ele) => ['Company_Details', 'Shipping_Details', 'Supplier_factory'].includes(ele));
    if (item?.type === 'container') {
      toggleEditPopup();
      if (item.key === 'Section') {
        updatedLeft?.map((ele) => {
          ele?.components?.map((element) => {
            if (element?.id === item?.id && !['Company_Details', 'Shipping_Details', 'Supplier_factory'].includes(item?.key)) {
              element.id = incrementCounter();
            }
            return element;
          });
          return ele;
        });
      } else {
        updatedLeft?.map((ele) => {
          ele?.templates?.map((element) => {
            if (element?.id === item?.id && !['Company_Details', 'Shipping_Details', 'Supplier_factory'].includes(item?.key)) {
              element.id = incrementCounter();
            }
            return element;
          });
          return ele;
        });
      }

      const hasItemAlready = arrayToCheck.includes(item?.key);
      if (hasItemAlready) {
        toasterMsg(
          `${t('ADD_PO_TEMPLATE_PROVIDER.THEY_CAN_ONLY_BE')} ${item?.label} ${t('ADD_PO_TEMPLATE_PROVIDER.IN_THE_PO_TEMPLATE')}`,
          `${t('ADD_PO_TEMPLATE_PROVIDER.DANGER')}`,
        );
      } else {
        newObject?.templateJsonSchema?.splice(index, 0, item);
      }
    }
    setPOTemplateState((oldState) => ({
      ...oldState,
      rigthColumn: newObject,
      leftColumn: updatedLeft,
    }));
  };

  const dropInLocation = (i, index, item, id, elementIndex) => {
    const newObject = poTemplateState?.rigthColumn;
    const parentIndex = elementIndex || newObject?.templateJsonSchema?.findIndex((ele) => ele.id === id);
    if (parentIndex !== -1) {
      toggleEditPopup();
      const leftCol = cloneDeep(poTemplateState?.leftColumn);
      leftCol?.map((ele) => {
        ele?.components?.map((element) => {
          if (element?.id === item?.id) {
            element.id = incrementCounter();
          }
          return element;
        });
        return ele;
      });
      newObject.templateJsonSchema?.[parentIndex]?.columns?.[index]?.splice(i, 0, {
        ...item,
        addingNew: true,
        id: incrementCounter(),
      });
      setPOTemplateState((previousState) => ({
        ...previousState,
        rigthColumn: newObject,
        leftColumn: leftCol,
      }));
    }
  };

  const deleteCard = (index) => {
    const object = cloneDeep(poTemplateState?.rigthColumn);
    object?.templateJsonSchema?.splice(index, 1);
    setPOTemplateState((otherStates) => ({
      ...otherStates,
      rigthColumn: object,
    }));
  };

  const redirectToListingPage = () => {
    const initObj = { ...initialState };
    initObj.leftColumn = poTemplatemodel;
    setPOTemplateState({ ...initObj });
    dispatch(componentAction.clearReducer());
    history.push({
      pathname: '/component-order/po-template',
    });
  };

  const handleSave = async () => {
    if (!poTemplateState?.poDetails?.name) {
      const rightData = cloneDeep(poTemplateState?.poDetails);
      rightData.nameErr = true;
      setPOTemplateState((allElement) => ({ ...allElement, poDetails: rightData }));
    } else {
      let res;
      if (id && !isDuplicate) {
        const data = {
          ...poTemplateState?.rigthColumn,
          name: poTemplateState?.poDetails?.name,
          image: poTemplateState?.poDetails?.image,
          isActive: poTemplateState?.poDetails?.isActive,
          templateJsonSchema: JSON.stringify(poTemplateState?.rigthColumn?.templateJsonSchema),
        };
        res = await dispatch(componentAction.editPOTemplate(id, data, t));
      } else {
        const data = {
          name: poTemplateState?.poDetails?.name,
          image: poTemplateState?.poDetails?.image,
          templateJsonSchema: JSON.stringify(poTemplateState?.rigthColumn?.templateJsonSchema),
          isActive: poTemplateState?.poDetails?.isActive,
        };
        res = await dispatch(componentAction.addPOTemplate(data, t));
      }
      if (res?.code === 200) {
        redirectToListingPage();
      }
    }
  };

  const modfiyReqAndEnable = (item, index) => {
    const editPopupValue = { ...item, forLabel: false };
    setPOTemplateState((otherStates) => ({
      ...otherStates,
      editPopup: true,
      editpopupData: editPopupValue,
      editPopupIndex: index,
    }));
  };

  const changeData = (obj, i) => {
    const updatedArray = cloneDeep(poTemplateState.rigthColumn);
    if (poTemplateState.editPopupIndex !== -1) {
      if (poTemplateState.editPopupChildIndex !== -1) {
        updatedArray.templateJsonSchema[poTemplateState?.editPopupParentIndex].columns[poTemplateState?.editPopupIndex][poTemplateState?.editPopupChildIndex] =
          obj;
      } else {
        updatedArray.templateJsonSchema[i] = obj;
      }
    }
    setPOTemplateState((oldData) => ({
      ...oldData,
      editPopup: false,
      editpopupData: null,
      editpopupChildData: null,
      editPopupIndex: -1,
      editPopupParentIndex: -1,
      editPopupChildIndex: -1,
      rigthColumn: updatedArray,
    }));
  };

  const handleCloseModel = () => {
    const updatedArray = cloneDeep(poTemplateState.rigthColumn);
    setPOTemplateState((otherStates) => ({
      ...otherStates,
      editPopup: false,
      editpopupData: null,
      editpopupChildData: null,
      editPopupIndex: -1,
      editPopupParentIndex: -1,
      editPopupChildIndex: -1,
      rigthColumn: updatedArray,
    }));
  };

  const duplicatingItem = (index, i, key) => {
    const rightSide = cloneDeep(poTemplateState?.rigthColumn);
    rightSide?.templateJsonSchema?.map((ele) => {
      if (ele.key === key) {
        const item = ele?.columns[index][i];
        ele?.columns[index]?.splice(i, 0, {
          ...item,
          addingNew: true,
          id: incrementCounter(),
        });
      }
      return ele;
    });
    setPOTemplateState((oldState) => ({
      ...oldState,
      rigthColumn: rightSide,
    }));
  };

  const deleteItem = (index, i, key, mainIndex) => {
    const rightSide = cloneDeep(poTemplateState?.rigthColumn);
    rightSide?.templateJsonSchema?.map((ele, eleIndex) => {
      if (eleIndex === mainIndex) {
        if (index === 0 && ele.columns[0].length === 1) {
          ele.key === key && ele.columns[index].splice(i, 1);
          ele.columns[0] = ele.columns[1];
          ele.columns[1] = [];
        } else {
          ele.key === key && ele.columns?.[index]?.splice(i, 1);
        }
      }
      return ele;
    });

    setPOTemplateState((oldState) => ({
      ...oldState,
      rigthColumn: rightSide,
    }));
  };

  const editingInput = (index, i, foundIndex) => {
    const rightSide = cloneDeep(poTemplateState?.rigthColumn);
    const editPopupChildValue = rightSide?.templateJsonSchema[foundIndex]?.columns[index][i];
    setPOTemplateState((oldState) => ({
      ...oldState,
      editPopup: true,
      editpopupData: rightSide?.templateJsonSchema[foundIndex],
      editpopupChildData: editPopupChildValue,
      editPopupIndex: index,
      editPopupParentIndex: foundIndex,
      editPopupChildIndex: i,
    }));
  };

  const changeLabel = (element, index) => {
    const editPopupValue = { ...element, forLabel: true };
    setPOTemplateState((oldState) => ({
      ...oldState,
      editPopup: true,
      editpopupData: editPopupValue,
      editPopupIndex: index,
    }));
  };

  const contextValue = useMemo(
    () => ({
      poTemplateState,
      setPOTemplateState,
      imageSrc,
      onChangeForData,
      dropLocation,
      dropInLocation,
      deleteCard,
      handleSave,
      modfiyReqAndEnable,
      changeData,
      toggleEditPopup,
      handleCloseModel,
      duplicatingItem,
      deleteItem,
      editingInput,
      changeLabel,
      redirectToListingPage,
      userInfo,
    }),
    [
      poTemplateState,
      imageSrc,
      onChangeForData,
      dropLocation,
      dropInLocation,
      deleteCard,
      handleSave,
      modfiyReqAndEnable,
      changeData,
      toggleEditPopup,
      handleCloseModel,
      duplicatingItem,
      deleteItem,
      editingInput,
      changeLabel,
      redirectToListingPage,
      userInfo,
    ],
  );
  return (
    <StateContext.Provider
      value={{
        ...contextValue,
      }}
    >
      {children}
    </StateContext.Provider>
  );
}

export function usePOTemplateOrderState() {
  const context = useContext(StateContext);
  const { t } = useTranslation('common');
  if (!context) {
    throw new Error(t('ADD_PO_TEMPLATE_PROVIDER.STATE_PROVIDER'));
  }
  return context;
}
